
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface WarehouseInspectionHeaderProps {
  onBack: () => void;
  procurementId: string;
}

const WarehouseInspectionHeader: React.FC<WarehouseInspectionHeaderProps> = ({
  onBack,
  procurementId
}) => {
  return (
    <div className="flex items-center gap-4">
      <Button variant="ghost" onClick={onBack}>
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to Warehouse
      </Button>
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Warehouse Inspection</h1>
        <p className="text-muted-foreground">
          Review and inspect procurement ID: {procurementId.substring(0, 8)}...
        </p>
      </div>
    </div>
  );
};

export default WarehouseInspectionHeader;
